import React, { forwardRef, useState } from "react";
import PropTypes from "prop-types";
import "../../../styles/DateTime.scss";
import DatePicker from "react-datepicker";
import { Button } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";

const DATE_PLACEHOLDER = "mm/dd/yyyy";

const DateInput = forwardRef(({ value, onClick }, ref) => (
  <Button
    onClick={onClick}
    ref={ref}
    disableRipple
    fullWidth
    endIcon={<EventIcon color="text.main" />}
    data-testid="date-picker-button"
    sx={(theme) => ({
      width: "100%",
      color: value ? theme.palette.text.primary : theme.palette.text.disabled,
      letterSpacing: 0,
      border: "1px solid #4d4d4d",
      borderRadius: "8px",
      padding: "8px 10px 8px 10px !important",
      justifyContent: "space-between",
      textTransform: "none",
      fontFamily: theme.typography.body1,
    })}
  >
    {value || DATE_PLACEHOLDER}
  </Button>
));

DateInput.displayName = "DateInput";

DateInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
};

const EMPDatePicker = (props) => {
  const {
    incomingDate,
    transportFormData,
    startAtToday,
    showTimeSelect,
    maxDate,
    minDate,
  } = props;

  const [date, setDate] = useState(incomingDate);

  let resolvedMinDate;

  if (minDate) {
    resolvedMinDate = minDate;
  } else if (startAtToday) {
    resolvedMinDate = new Date();
  }

  const handleChange = (value) => {
    setDate(value);

    if (showTimeSelect) {
      return transportFormData(
        value.toLocaleDateString("en-CA") +
          " " +
          value.toLocaleTimeString([], {
            hour12: false,
          })
      );
    }

    return transportFormData(value);
  };

  return (
    <DatePicker
      {...props}
      data-testid="date-picker"
      selected={date}
      minDate={resolvedMinDate}
      maxDate={maxDate}
      showTimeSelect={showTimeSelect}
      dateFormat={showTimeSelect ? "EEEE, MMMM do yyyy p" : "MM/dd/yyyy"}
      calendarClassName="emp-datepicker"
      onChange={handleChange}
      customInput={<DateInput />}
    />
  );
};

EMPDatePicker.propTypes = {
  incomingDate: PropTypes.instanceOf(Date),
  transportFormData: PropTypes.func,
  startAtToday: PropTypes.bool,
  showTimeSelect: PropTypes.bool,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
};

export default EMPDatePicker;
